import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M1.5 1.1h1c.7 0 1.4.5 1.5 1.2l2.6 15.5c.1.7.7 1.2 1.5 1.2H18"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M16.1 21.4c.2 0 .4.2.4.4s-.2.4-.4.4m0-.8c-.2 0-.4.2-.4.4s.2.4.4.4m-7.5-.8c.2 0 .4.2.4.4s-.2.4-.4.4m0-.8c-.2 0-.4.2-.4.4s.2.4.4.4"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4.5 5.6h17.4c.4.1.6.5.5.9L21 12.4c-.3 1.3-1.5 2.3-2.9 2.3H6"
    }, null, -1)
  ]));
}
const shoppingCart = { render };
export {
  shoppingCart as default,
  render
};
//# sourceMappingURL=shopping-cart.svg.js.map
